import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
} from "./action-types";

import { ProfileActions, ProfileState } from "./types";

const initialState: ProfileState = {
  pending: false,
  error: null,
  profiles: null,
};

export default (state = initialState, action: ProfileActions) => {
  switch (action.type) {
    case FETCH_PROFILE_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
        profiles: action.payload.profiles,
      };
    case FETCH_PROFILE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};
